import { Alert, Box, Button, Center, Heading, Image, Stack, Text, VStack } from '@chakra-ui/react'
import { useColorModeValue } from './ui/color-mode'
import nygovLogo from '../assets/nygov-logo.png'
import { login } from '@/api';
import { useAuth } from './ui/auth-context';

interface LoginProps { 
    fontFamily?: string;
}

export const Login = (props: LoginProps) => {
    const { user, isUnauthorized, isLoggedOut } = useAuth();
    const {fontFamily} = props;

    const handleLogin = async () => {
        try {
            const { redirectUrl } = await login();
            if (redirectUrl) {
                window.location.href = redirectUrl;
            }
        } catch (error) {
            console.error('Login failed:', error);
        }
    };

    return (
        <Center fontFamily={fontFamily} height="100vh" bg={useColorModeValue('gray.50', 'gray.900')}>
            <Box
                p={8}
                maxWidth="400px"
                borderWidth={1}
                borderRadius={8}
                boxShadow="lg"
                bg={useColorModeValue('white', 'gray.800')}
            >
                <VStack gap={6} align="stretch">
                    <Center>
                        <Image src={nygovLogo} alt="NY.gov Logo" height="60px" />
                    </Center>

                    {isLoggedOut && (
                        <Alert.Root status="info">
                            <Alert.Indicator />
                            <Alert.Content>
                                <Alert.Title>You have been logged out.</Alert.Title>
                            </Alert.Content>
                        </Alert.Root>
                    )}

                    {isUnauthorized && (
                        <Alert.Root status="error">
                            <Alert.Indicator />
                            <Alert.Content>
                                <Alert.Title>Access Denied</Alert.Title>
                                <Alert.Description>
                                    You are not authorized to access this application.
                                </Alert.Description>
                            </Alert.Content>
                        </Alert.Root>
                    )}

                    <Stack fontFamily={'proxima nova'} gap={2} textAlign="center">
                        <Heading fontFamily={fontFamily} size="xl">Welcome</Heading>
                        <Text color="fg.muted">Please sign in to access the application</Text>
                    </Stack>
                    <Button
                        colorPalette="blue"
                        size="lg"
                        onClick={handleLogin}
                        fontWeight="bold"
                    >
                        Sign in to ny.gov
                    </Button>
                </VStack>
            </Box>
        </Center>
    );
};
